/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updateyourbusinessaddress3Inputs */

const en_updateyourbusinessaddress3 = /** @type {(inputs: Updateyourbusinessaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your business address`)
};

const de_updateyourbusinessaddress3 = /** @type {(inputs: Updateyourbusinessaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere die Adresse deines Unternehmens`)
};

/**
* | output |
* | --- |
* | "Update your business address" |
*
* @param {Updateyourbusinessaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updateyourbusinessaddress3 = /** @type {((inputs?: Updateyourbusinessaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updateyourbusinessaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updateyourbusinessaddress3(inputs)
	return de_updateyourbusinessaddress3(inputs)
});
export { updateyourbusinessaddress3 as "updateYourBusinessAddress" }